import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import {
  changePassword,
  resetPasswordChangeMessage,
} from "../../../store/slices/authSlice";
import { FaEyeSlash, FaEye, FaArrowAltCircleLeft } from "react-icons/fa";
import styles from "./Profile.module.scss";
import { useNavigate } from "react-router-dom";

const Security = () => {
  const navigate = useNavigate();
  const handleClick = (url) => {
    navigate(url);
  };
  const [data, setData] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
    userId: "",
  });
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    password: false,
    confirmPassword: false,
  });
  const dispatch = useDispatch();
  const {
    userInfo,
    passwordChangeSuccessMessage,
    passwordChangeErrorMessage,
    token,
  } = useSelector((state) => state.auth);

useEffect(() => {
  if (passwordChangeSuccessMessage) {
    showToastifySuccess(passwordChangeSuccessMessage);
    setData({
      oldPassword: "",
      password: "",
      confirmPassword: "",
      userId: "",
    });
    setErrors({ password: "", confirmPassword: "" });
    dispatch(resetPasswordChangeMessage(null));
  }
  if (passwordChangeErrorMessage) {
    showToastifyError(passwordChangeErrorMessage);
    dispatch(resetPasswordChangeMessage(null));
  }
}, [dispatch, passwordChangeSuccessMessage, passwordChangeErrorMessage]);

  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "password") {
      if (!passwordPattern.test(value)) {
        setErrors((prev) => ({
          ...prev,
          password:
            "Password must have at least 8 characters, one uppercase, one lowercase, one number, and one special character.",
        }));
      } else {
        setErrors((prev) => ({ ...prev, password: "" }));
      }
    }
    if (name === "confirmPassword") {
      if (value !== data.password) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Passwords do not match.",
        }));
      } else {
        setErrors((prev) => ({ ...prev, confirmPassword: "" }));
      }
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (errors.password || errors.confirmPassword) return;
    dispatch(
      changePassword({
        oldPassword: data.oldPassword,
        password: data.password,
        confirmPassword: data.confirmPassword,
        userId: userInfo._id,
        token,
      })
    );
  };

  const toggleShowPassword = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  return (
    <Row>
      <div className={styles["goback-div"]}>
        <h3>Security Settings</h3>
        <div>
          <p className="text-end" onClick={() => handleClick("/settings")}>
            <span>
              <FaArrowAltCircleLeft />
            </span>
            Go To List
          </p>
        </div>
      </div>
      <Col md={6}>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="currentPassword">
            <Form.Label>Current Password</Form.Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d3d3d3",
                borderRadius: "0.5rem",
              }}
            >
              <Form.Control
                name="oldPassword"
                type={showPassword.oldPassword ? "text" : "password"}
                placeholder="Enter current password"
                value={data.oldPassword}
                onChange={handleChange}
                style={{ flex: 1, border: "none" }}
                required
              />
              <span
                className="input-group-text"
                onClick={() => toggleShowPassword("oldPassword")}
              >
                {showPassword.oldPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </Form.Group>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d3d3d3",
                borderRadius: "0.5rem",
              }}
            >
              <Form.Control
                name="password"
                type={showPassword.password ? "text" : "password"}
                placeholder="Enter new password"
                value={data.password}
                onChange={handleChange}
                style={{ flex: 1, border: "none" }}
                required
              />
              <span
                className="input-group-text"
                onClick={() => toggleShowPassword("password")}
              >
                {showPassword.password ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.password && (
              <small className="text-danger">{errors.password}</small>
            )}
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>Confirm New Password</Form.Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d3d3d3",
                borderRadius: "0.5rem",
              }}
            >
              <Form.Control
                name="confirmPassword"
                type={showPassword.confirmPassword ? "text" : "password"}
                placeholder="Confirm new password"
                value={data.confirmPassword}
                onChange={handleChange}
                style={{ flex: 1, border: "none" }}
                required
              />
              <span
                className="input-group-text"
                onClick={() => toggleShowPassword("confirmPassword")}
              >
                {showPassword.confirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.confirmPassword && (
              <small className="text-danger">{errors.confirmPassword}</small>
            )}
          </Form.Group>
          <Button variant="primary" type="submit" className="p-1">
            Change Password
          </Button>
        </Form>
      </Col>
    </Row>
  );
};

export default Security;
